import { forwardRef, Fragment, useState } from "react";
import { useTranslate } from "react-admin";
import { MenuItem, Typography } from "@mui/material";

import { CreateInvoiceDialog } from "organisms";

function CreateInvoiceDialogMenuItem(props, ref) {
  const { parentInvoice, event, closeMenu, bookingsWithAttendees, refreshBooking = null, label = null } = props;
  const translate = useTranslate();
  const [dialogIsOpen, setDialogIsOpen] = useState(false);

  function openDialog() {
    closeMenu();
    setDialogIsOpen(true);
  }
  const finalLabel = label
    ? translate(label)
    : translate("resources.bookings.actions.create_invoices", { smart_count: bookingsWithAttendees.length });

  return (
    <Fragment>
      <MenuItem ref={ref} onClick={openDialog}>
        <Typography>{finalLabel}</Typography>
      </MenuItem>

      <CreateInvoiceDialog
        label={finalLabel}
        parentInvoice={parentInvoice}
        dialogIsOpen={dialogIsOpen}
        setDialogIsOpen={setDialogIsOpen}
        event={event}
        bookingsWithAttendees={bookingsWithAttendees}
        refreshBooking={refreshBooking}
      />
    </Fragment>
  );
}

export default forwardRef(CreateInvoiceDialogMenuItem);
